import { SetStateAction, useCallback, useState } from "react";

interface IStorageItem<T = any> { data: T, createdAt: number };


type IUseLocalStorageData<T> = [
    T,
    (value: SetStateAction<T>) => void
];


export const useLocalStorage = <T>(key: string, initialValue: T): IUseLocalStorageData<T> => {

    const getInitialState = (): T => {
        try {

            const item = window.localStorage.getItem(key);

            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // console.log(error);
            window.localStorage.removeItem(key)
            return initialValue
        }
    };


    const [storedValue, setStoredValue] = useState<T>(getInitialState());

    const setValue = useCallback((value: SetStateAction<T>) => {
        try {

            setStoredValue((prev) => {
                // Allow value to be a function so we have same API as useState
                const valueToStore = value instanceof Function ? value(prev) : value;
                window.localStorage.setItem(key, JSON.stringify(valueToStore));

                return valueToStore
            });

        } catch (error) {

            //  console.log(error);
        }
    }, [key]);

    return [storedValue, setValue];
}